export const CONTENT_TYPE = 'Content-Type';
export const VERSION = 'version';
export const VERSION_VALUE = 2.0;
export const VERSION_3_0 = 3.0;
export const APPLICATION_JSON = 'application/json';
export const TEXT_HTML = 'text/html';
export const MULTI_FORM_DATA = 'multipart/form-data';
export const ACCEPT_TYPE = 'Accept';
export const FORM_URL_ENCODED = 'application/x-www-form-urlencoded';
